import { render, staticRenderFns } from "./pro-list.vue?vue&type=template&id=3ba76bfc&scoped=true&"
import script from "./pro-list.vue?vue&type=script&lang=js&"
export * from "./pro-list.vue?vue&type=script&lang=js&"
import style0 from "./pro-list.vue?vue&type=style&index=0&id=3ba76bfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba76bfc",
  null
  
)

export default component.exports